import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, defaultCalendarHolidays }) =>
    present(
      repository
        .assignDefaultCalendarHolidaysToPlanzone(
          planzone,
          defaultCalendarHolidays,
        )
        .then((savedPlanzone) => ({
          planzone: savedPlanzone,
          defaultCalendarHolidays,
        }))
        .catch((error) =>
          Promise.reject({ error, planzone, defaultCalendarHolidays }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
